var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x86\x88",
    d: "M10.9901 10.0048C10.9901 9.55646 10.8129 9.17066 10.4688 8.82656L2.46079 1.01669C2.18968 0.745588 1.85602 0.599609 1.45979 0.599609C0.646478 0.599609 0 1.24609 0 2.04897C0 2.4452 0.156406 2.82057 0.448364 3.11253L7.53877 9.9944L0.448364 16.8867C0.166833 17.1786 0 17.5436 0 17.9502C0 18.7531 0.646478 19.3996 1.45979 19.3996C1.85602 19.3996 2.18968 19.2536 2.47121 18.9825L10.4688 11.1727C10.8233 10.8077 10.9901 10.4428 10.9901 10.0048Z",
    fill: "#F0B323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon);
export default __webpack_public_path__ + "static/media/list icon.606f74df3a97a2c9e4fd63ec734e1aa6.svg";
export { ForwardRef as ReactComponent };